import React from "react";
import "./ErrorPage.css";
const ErrorPage = () => {
  return (
    <div id="error_page">
      <section className="page_404">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 ">
              <div className="col-sm-10 col-sm-offset-1  text-center">
                <div className="four_zero_four_bg">
                  <h1 className="text-center ">Opps</h1>
                </div>

                <div className="contant_box_404">
                  <h3 className="h2">Look like you're lost</h3>

                  <p>Unfortunately the page you are looking for has been moved or deleted</p>

                  <a href="/" className="link_404">
                    Back to Homepage
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ErrorPage;
